import Service from "../../AuthService";

const Bank = {
    getBank(page) {
        return Service.get("/bank?page="+page);
    },
    getBankAll(){
        return Service.get("/bank_all");
    },
    getBankById(id) {
        return Service.get("/bank/" + id)
    },
    createBank(data) {
        return Service.post("/bank", data)
    },
    updateBank(id, data) {
        return Service.put("/bank/" + id, data)
    },
    deleteBank(id) {
        return Service.delete("/bank/" + id)
    },

    //statement
    getStatement(bank_id,start_date,end_date){
        return Service.get("/statement?bank_id="+bank_id+
            "&start_date="+start_date+
            "&end_date="+end_date
        );
    },
    getMonthStatement(bank_id,start_date,end_date){
        return Service.get("/statement_month?bank_id="+bank_id+
            "&start_date="+start_date+
            "&end_date="+end_date
        );
    },
    //sum statement
    getSumStatement(bank_id,start_date,end_date){
        return Service.get("/getsumstatement?bank_id="+bank_id+
            "&start_date="+start_date+
            "&end_date="+end_date
        );
    },
    showStatement(id){
        return Service.get('/statement/'+id);
    },
    editStatement(id,data){
      return Service.put('/statement/'+id,data);
    },
    saveStatement(data){
        return Service.post("/statement",data);
    },
    deleteStatement(id){
        return Service.delete('/statement/'+id);
    },

    //branch bank
    getBankBranch(page){
        return Service.get("/branch_bank_table?page="+page);
    },
    showBankBranch(id){
        return Service.get("/branch_bank_table/"+id);
    },
    createBankBranch(data){
        return Service.post("/branch_bank_table",data);
    },
    updateBankBranch(id,data){
        return Service.put("/branch_bank_table/"+id,data);
    },
    deleteBankBranch(id){
        return Service.delete("/branch_bank_table/"+id);
    },
    searchBankBranch(page,data){
        return Service.get("/search_branch_bank?page=" +page+
            '&code='+data.code+
            '&bank_id='+data.bank_id);
    }
};

export default Bank
